import React from 'react'
import { TabPanel } from 'primereact/tabview'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Cnpj, CustomTabView } from '../../../../components'
import ModalCliente from '../../Cadastros/Cliente/ModalCliente/ModalCliente'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showMessageBox } from '../../../../store/actions/system.actions'
import ModalProdutoEan from '../../Cadastros/Produto/ModalProdutoEan'
import ModalProduto from '../../Cadastros/Produto/ModalProduto'
import GrupoProdutoHttp from '../../../../services/api/https/registration/grupo-produto.http'

const ModalName = {
  CLIENT: 'client',
  PRODUCT: 'product',
  INCONSISTENT_PRODUCT: 'inconsistent_product',
  NONE: 'none',
}

function TabsClientesEhProdutosNaoCadastrados({
  produtosSemCadastros = [],
  clientesSemCadastros = [],
  produtosComInconsistencia = [],
  companyId,
  selectedCiclo,
  selectedTp,
  dispatch,
}) {
  // Vars
  const hasClientesSemCadastro = clientesSemCadastros.length > 0
  const hasProdutosSemCadastro = produtosSemCadastros.length > 0
  const hasProdutosComInconsistencia = produtosComInconsistencia.length > 0
  const selectedCompanyId =
    companyId !== null && companyId !== undefined
      ? companyId
      : selectedCiclo
        ? selectedCiclo.empresaDeId || selectedCiclo.empresaId
        : null

  let activeIndex = 0
  if (!hasClientesSemCadastro && hasProdutosSemCadastro) activeIndex = 1
  if (!hasClientesSemCadastro && !hasProdutosSemCadastro && hasProdutosComInconsistencia)
    activeIndex = 2

  // Hooks
  const [state, setState] = React.useState({
    showModal: ModalName.NONE,
    clienteNaoCadastrado: undefined,
    produtoNaoCadastrado: undefined,
    produtoComInconsistencia: undefined,
    produtosSemCadastros: [],
    clientesSemCadastros: [],
    produtosComInconsistencia: [],
    gruposProduto: [],
  })

  React.useEffect(() => {
    setState(prev => ({
      ...prev,
      produtosSemCadastros,
      clientesSemCadastros,
      produtosComInconsistencia,
    }))
  }, [produtosSemCadastros, clientesSemCadastros, produtosComInconsistencia])

  React.useEffect(() => {
    if (!selectedCompanyId) return

    GrupoProdutoHttp.getGrupos(selectedCompanyId)
      .then(grupos => {
        setState(prev => ({ ...prev, gruposProduto: grupos }))
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
      })
  }, [selectedCompanyId])

  const getProdutoInconsistenteModalData = () => {
    if (!state.produtoComInconsistencia) return null

    const produto = state.produtoComInconsistencia
    return {
      id: produto.id,
      product_code: produto.product_code || produto.code || '',
      company_id: produto.company_id || selectedCompanyId || '',
      name: produto.name || '',
      weight: produto.weight || '',
      unit_sku: produto.unit_sku || '',
      m3: produto.m3 || '',
      actived: produto.actived === undefined ? true : produto.actived,
      ordem_separacao: produto.ordem_separacao || '',
      caixa_com_peso_variavel:
        produto.caixa_com_peso_variavel === undefined ? false : produto.caixa_com_peso_variavel,
      grupo_produto_id: produto.grupo_produto_id || '',
      weight_liquido: produto.weight_liquido || '',
      qte_por_pallet: produto.qte_por_pallet || '',
      dias_para_vencimento: produto.dias_para_vencimento || '',
      participa_calculo_paletizacao:
        produto.participa_calculo_paletizacao === undefined
          ? true
          : produto.participa_calculo_paletizacao,
      picking_add_lote: produto.picking_add_lote === undefined ? false : produto.picking_add_lote,
      picking_add_data_validade:
        produto.picking_add_data_validade === undefined ? false : produto.picking_add_data_validade,
      picking_add_data_fabricacao:
        produto.picking_add_data_fabricacao === undefined
          ? false
          : produto.picking_add_data_fabricacao,
      picking_add_info_complementar:
        produto.picking_add_info_complementar === undefined
          ? false
          : produto.picking_add_info_complementar,
      picking_add_lote_recebimento:
        produto.picking_add_lote_recebimento === undefined
          ? false
          : produto.picking_add_lote_recebimento,
      picking_add_data_validade_recebimento:
        produto.picking_add_data_validade_recebimento === undefined
          ? false
          : produto.picking_add_data_validade_recebimento,
      un_agregadora: produto.un_agregadora || '',
      un_fracionada: produto.un_fracionada || '',
    }
  }

  const getInconsistencyMessage = () => {
    if (
      !state.produtoComInconsistencia ||
      !Array.isArray(state.produtoComInconsistencia.inconsistencies)
    )
      return null
    if (state.produtoComInconsistencia.inconsistencies.length === 0) return null
    return state.produtoComInconsistencia.inconsistencies.join('; ')
  }

  // Render
  return (
    <>
      <CustomTabView activeIndex={activeIndex}>
        <TabPanel header="Clientes Não Cadastrados" disabled={!hasClientesSemCadastro}>
          <DataTable
            selectionMode="single"
            onSelectionChange={e => {
              if (selectedTp === 0) {
                dispatch(showMessageBox(null, 'Selecione o Operador Logístico'))
              } else {
                setState(prev => ({
                  ...prev,
                  showModal: ModalName.CLIENT,
                  clienteNaoCadastrado: e.value,
                }))
              }
            }}
            paginator={true}
            rows={10}
            value={state.clientesSemCadastros}
          >
            <Column field="code" header="Código" style={tableCellCentered(180)} />
            <Column field="razao" header="Razão Social" />
            <Column field="fantasia" header="Fantasia" />
            <Column
              field="cnpj"
              header="CNPJ/CPF"
              style={tableCellCentered(180)}
              body={cliente => <Cnpj>{cliente.cnpj}</Cnpj>}
              bodyStyle={tableCellCentered(180)}
            />
          </DataTable>
        </TabPanel>

        <TabPanel header="Produtos Não Cadastrados" disabled={!hasProdutosSemCadastro}>
          <DataTable
            selectionMode="single"
            onSelectionChange={e =>
              setState(prev => ({
                ...prev,
                showModal: ModalName.PRODUCT,
                produtoNaoCadastrado: e.value,
              }))
            }
            paginator={true}
            rows={10}
            value={state.produtosSemCadastros}
            className="auto-layout"
          >
            <Column field="code" header="Código" style={tableCellCentered(200)} />
            <Column field="name" header="Produto" />
            <Column field="ean" header="EAN" style={tableCellCentered(200)} />
            <Column field="dun" header="DUN" style={tableCellCentered(200)} />
          </DataTable>
        </TabPanel>

        <TabPanel header="Produtos Inconsistentes" disabled={!hasProdutosComInconsistencia}>
          <DataTable
            selectionMode="single"
            onSelectionChange={e =>
              setState(prev => ({
                ...prev,
                showModal: ModalName.INCONSISTENT_PRODUCT,
                produtoComInconsistencia: e.value,
              }))
            }
            paginator={true}
            rows={10}
            value={state.produtosComInconsistencia}
            className="auto-layout"
          >
            <Column field="code" header="Código" style={tableCellCentered(200)} />
            <Column field="name" header="Produto" />
          </DataTable>
        </TabPanel>
      </CustomTabView>

      <ModalCliente
        onModalClose={() => setState(prev => ({ ...prev, showModal: ModalName.NONE }))}
        show={state.showModal === ModalName.CLIENT}
        onModalSave={cliente => {
          setState(prev => ({
            ...prev,
            clientesSemCadastros: prev.clientesSemCadastros.filter(
              c => c.code !== cliente.company_code,
            ),
            showModal: ModalName.NONE,
          }))
        }}
        associateWithSelectedCycle={true}
        selectedCliente={{
          company_code:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.code
              ? state.clienteNaoCadastrado.code
              : '',
          razaoSocial:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.razao
              ? state.clienteNaoCadastrado.razao
              : '',
          nomeFantasia:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.fantasia
              ? state.clienteNaoCadastrado.fantasia
              : '',
          cnpj:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.cnpj
              ? state.clienteNaoCadastrado.cnpj
              : '',
          address:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.address
              ? state.clienteNaoCadastrado.address
              : '',
          district:
            state.clienteNaoCadastrado && state.clienteNaoCadastrado.district
              ? state.clienteNaoCadastrado.district
              : '',
        }}
      />

      <ModalProdutoEan
        visible={state.showModal === ModalName.PRODUCT}
        onResponse={(type, produto) => {
          switch (type) {
            case 'success':
              setState(prev => ({
                ...prev,
                showModal: ModalName.NONE,
                produtosSemCadastros: prev.produtosSemCadastros.filter(
                  p => p.code !== produto.product_code,
                ),
                produtoNaoCadastrado: undefined,
              }))
              break
            case 'error':
              dispatch(showMessageBox(null, produto))
              break
            case 'close':
              setState(prev => ({
                ...prev,
                showModal: ModalName.NONE,
              }))
              break
            default:
              break
          }
        }}
        selectedProduto={{
          product_code:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.code
              ? state.produtoNaoCadastrado.code
              : '',
          name:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.name
              ? state.produtoNaoCadastrado.name
              : '',
          company_id: selectedCompanyId,
          ean:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.ean
              ? state.produtoNaoCadastrado.ean
              : '',
          dun:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.dun
              ? state.produtoNaoCadastrado.dun
              : '',
          m3:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.m3
              ? state.produtoNaoCadastrado.m3
              : '',
          un_agregadora:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.un_agregadora
              ? state.produtoNaoCadastrado.un_agregadora
              : '',
          un_fracionada:
            state.produtoNaoCadastrado && state.produtoNaoCadastrado.un_fracionada
              ? state.produtoNaoCadastrado.un_fracionada
              : '',
        }}
      />

      {state.showModal === ModalName.INCONSISTENT_PRODUCT && state.produtoComInconsistencia ? (
        <ModalProduto
          show={true}
          data={getProdutoInconsistenteModalData()}
          grupos={state.gruposProduto}
          alertMessage={getInconsistencyMessage()}
          onModalClose={() => {
            setState(prev => ({
              ...prev,
              showModal: ModalName.NONE,
              produtoComInconsistencia: undefined,
            }))
          }}
          onModalSave={produto => {
            setState(prev => ({
              ...prev,
              showModal: ModalName.NONE,
              produtosComInconsistencia: prev.produtosComInconsistencia.filter(
                p => p.code !== produto.product_code,
              ),
              produtoComInconsistencia: undefined,
            }))
          }}
        />
      ) : null}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp }, ciclo_entrega: { selectedCiclo } }) => ({
  selectedCiclo,
  selectedTp,
})

export default connect(mapStateToProps)(withRouter(TabsClientesEhProdutosNaoCadastrados))
